<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="6" md="4">
        <v-select
            @change="filterModelTypeChange"
            :items="periods"
            label="Select period"
            item-value="id"
            item-text="name"
            persistent-hint>
        </v-select>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
            v-model="filterModel.year"
            :items="years"
            label="Select year"
            item-text="name"
            item-value="id"
            persistent-hint>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-btn large block color="primary" @click="filterIncomeStatement">Filter</v-btn>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-toolbar-title>Balance sheet</v-toolbar-title>
      </v-col>
      <v-data-table
          :headers="dataTable.headers"
          :items="dataTable.data"
          :item-class="itemRowBackground"
          :items-per-page="dataTable.data.length"
          class="statement-table"
          hide-default-footer
      ></v-data-table>
    </v-row>
  </v-container>
</template>

<script>
import BalanceSheetFilter from "@/models/reports/balance_sheet_filter";
import BalanceSheetModel from "@/models/reports/balance_sheet_model";
import {mapGetters} from "vuex";

export default {
  name: "BalanceSheet",
  data() {
    return {
      filterModel: new BalanceSheetFilter(),
      years: [],
      loaded: false,
      dataTable: new BalanceSheetModel(),
      periods: [
        {
          id: 'annual',
          name: 'Annual'
        },
        {
          id: 'quarterly',
          name: 'Quarterly'
        },
        {
          id: 'monthly',
          name: 'Monthly'
        }
      ]
    }
  },
  created() {
    let currentYear = new Date().getFullYear();
    let startYear = new Date().getFullYear() - 100;
    while (currentYear >= startYear) {
      let year = currentYear--;
      this.years.push({
        id: year,
        name: year
      });
    }
  },
  computed: {
    ...mapGetters(['activeProjectId', 'balanceSheet'])
  },
  methods: {
    itemRowBackground: function (item) {
      if (item.level == 1) {
        return 'primary-row ' + item.type;
      } else if (item.level == 2) {
        return 'secondary-row ' + item.type;
      } else {
        return 'third-row ' + item.type;
      }
    },
    filterModelTypeChange(value) {
      this.loaded = false;
      this.filterModel.type = value;
      this.filterModel.year = '';

      if (value === 'annual') {
        this.years.unshift({
          id: 'all',
          name: 'All'
        });
      } else {
        this.years = this.years.filter(x => x.id !== 'all');
      }
    },
    async filterIncomeStatement() {
      this.filterModel.project_id = this.activeProjectId;
      let filter = {
        ...this.filterModel
      };

      await this.$store.dispatch('balanceSheet', { filter });
      this.loaded = true;

      this.dataTable.prepareData(this.balanceSheet);
    },
  }
}
</script>

<style>
  .statement-table {
    width: 100%;
  }
  .statement-table table {
    border-collapse: collapse;
  }
  .statement-table tr td:first-child {
    min-width: 250px;
    white-space: nowrap;
  }
  .statement-table th:not(:nth-child(1)) {
    font-size: 1rem !important;
    white-space: nowrap;
  }

  .primary-row {
    background: #38321C;
    color: #ffffff;
  }
  .primary-row td {
    border-collapse: collapse;
    border: 1px solid #ffffff;
  }
  .primary-row:hover {
    background: rgba(56, 50, 28, 0.6) !important;
  }
  .primary-row td:first-child {
    font-size: 1rem !important;
    font-weight: 500;
  }

  .secondary-row {
    background-color: #ffffff;
  }
  .secondary-row td:first-child {
    font-weight: bold;
    font-size: 0.9rem !important;
    text-align: center !important;
  }
  .secondary-row td {
    height: 42px !important;
  }
  .secondary-row:hover {
    background-color: #c4c4c4;
  }

  .third-row.income td:not(:first-child, :nth-last-child(2), :nth-last-child(1)) {
    background: #B7E1CD;
  }
  .third-row td:first-child {
    font-size: 0.8rem !important;
    text-align: right !important;
  }
  .third-row td {
    height: 36px !important;
  }
  .third-row.income:hover td:not(:first-child, :nth-last-child(2), :nth-last-child(1)) {
    background: rgba(183, 225, 205, 0.6) !important;
  }
  .third-row.income td:nth-last-child(2) {
    background: #6AC6B3 !important;
  }
  .third-row.expense td:not(:first-child, :nth-last-child(2), :nth-last-child(1)) {
    background: #F5CDCC;
  }
  .third-row.expense:hover td:not(:first-child, :nth-last-child(2), :nth-last-child(1)) {
    background: rgba(230, 105, 105, 0.6) !important;
  }
  .third-row.expense td:nth-last-child(2) {
    background: #EABA7D !important;
  }
</style>